<div class="block bg-[var(--p-content-background)] px-3 pt-[5px] pb-2">
  @if (item().isStartOfDay) {
    <div
      [ngClass]="{ 'font-bold': isToday(item().createdOn) }"
      class="min-h-10 text-sm text-muted-color text-center mx-[68px] mt-0.5 pt-2.5"
    >
      {{ item().createdOn | chatDate: locale() }}
    </div>
  }

  <div class="mx-1.5 mt-1.5" [id]="Id">
    <div class="flex h-[23px]">
      <button
        type="button"
        class="p-0 shadow-none border-0 bg-none bg-transparent outline-none focus-visible:shadow-[0px_0px_0px_3px_rgba(0,115,208,0.24)] cursor-pointer opacity-30 [transform:scaleX(-1)] -ml-1 w-6"
        [attr.aria-label]="'ai_suggestions.tooltips.go_to_message' | translate"
        [pTooltip]="'ai_suggestions.tooltips.go_to_message' | translate"
        tooltipPosition="top"
        (click)="goToMessage()"
      >
        <i class="mi2-arrow-move text-2xl"></i>
      </button>
      <div class="text-[13px] font-normal leading-7 text-muted-color ml-1.5">
        {{ item().createdOn | date: 'shortTime' : undefined : translateService.currentLang }}
      </div>
    </div>

    <div
      class="text-sm font-semibold leading-[1.5] text-color break-words mb-2"
      [innerHTML]="item().body.content"
    ></div>
  </div>

  @for (data of item().body.suggestionMetaData; track data) {
    <div>
      @if (data.type === 'article') {
        <p-accordion [value]="item().articleExpanded ? 'article' : null" (valueChange)="onArticlePanelChange($event)">
          <p-accordion-panel value="article" [style]="{ 'border-bottom': 'none' }">
            <p-accordion-header
              [pt]="{ root: { class: '!bg-[var(--p-content-hover-background)] rounded mb-2' } }"
              styleClass="h-10 min-h-10"
            >
              <div
                class="bg-primary-500 rounded-[0.8em] text-white inline-block font-bold leading-[1.6em] mr-2.5 text-center w-[1.6em]"
              >
                {{ data.total }}
              </div>
              {{ 'ai_suggestions.articles' | translate }}
              @if (data.recommended) {
                <span
                  class="rounded bg-surface-400 float-right text-center mt-0.5 text-[10px] font-bold text-white px-1"
                  >{{ 'ai_suggestions.recommended' | translate }}</span
                >
              }
            </p-accordion-header>
            <p-accordion-content>
              @if (item().suggestArticlesResponse) {
                <div>
                  @for (article of item().suggestArticlesResponse.articleAnswersList; track article) {
                    <div>
                      <div
                        class="rounded border border-surface-200 bg-[var(--p-content-background)] px-2.5 py-0"
                        [ngStyle]="{ display: article.selected ? 'block' : 'none' }"
                      >
                        <div class="h-[205px] overflow-y-auto">
                          @if (article.recommended) {
                            <span
                              class="rounded bg-surface-400 text-center mt-1.5 mb-1.5 text-[10px] font-bold text-white px-1 inline-block"
                              >{{ 'ai_suggestions.recommended' | translate }}</span
                            >
                          }
                          <div class="mt-1.5">
                            <div class="text-sm font-semibold text-muted-color" [innerHTML]="article.title"></div>
                            @for (snippet of article.snippetsList; track snippet) {
                              <div>
                                <div
                                  class="text-[13px] font-normal text-muted-color mt-2.5"
                                  [innerHTML]="snippet"
                                ></div>
                                <div class="outline-none mt-2.5 mb-4">
                                  <p-button
                                    [outlined]="true"
                                    styleClass="text-sm font-semibold mt-1.5 mb-4 rounded-full"
                                    [label]="'ai_suggestions.send_snippet' | translate"
                                    (onClick)="sendSnippet(snippet, article)"
                                  />
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                        <div class="outline-none mt-2.5 mb-4">
                          <div class="inline-flex">
                            <button
                              type="button"
                              class="p-0 shadow-none border-0 bg-none bg-transparent outline-none focus-visible:shadow-[0px_0px_0px_3px_rgba(0,115,208,0.24)] relative inline-block mt-0.5 cursor-pointer w-[26px] opacity-50 mr-5"
                              [attr.aria-label]="'ai_suggestions.send_article' | translate"
                              [pTooltip]="'ai_suggestions.send_article' | translate"
                              tooltipPosition="right"
                              (click)="sendArticle(article)"
                            >
                              <i class="mi2-send text-2xl text-primary"></i>
                            </button>
                            <button
                              type="button"
                              class="p-0 shadow-none border-0 bg-none bg-transparent outline-none focus-visible:shadow-[0px_0px_0px_3px_rgba(0,115,208,0.24)] mt-0.5 cursor-pointer w-[26px] opacity-50"
                              [attr.aria-label]="'ai_suggestions.open_article' | translate"
                              [pTooltip]="'ai_suggestions.open_article' | translate"
                              tooltipPosition="top"
                              (click)="openArticle(article)"
                            >
                              <i class="mi2-outgoing-call-outline text-lg"></i>
                            </button>
                          </div>
                          <div class="float-right">
                            @if (showFeedback()) {
                              <button
                                type="button"
                                class="p-0 shadow-none border-0 bg-none bg-transparent outline-none focus-visible:shadow-[0px_0px_0px_3px_rgba(0,115,208,0.24)] mt-[3px] cursor-pointer w-[26px] opacity-85"
                                [attr.aria-label]="'ai_suggestions.feedback' | translate"
                                (click)="feedbackPopover.toggle($event); setSourceForFeedback(article)"
                              >
                                <i class="mi2-feedback text-lg"></i>
                              </button>
                              <p-popover #feedbackPopover appendTo="body">
                                <ng-container *ngTemplateOutlet="feedbackTooltipContent"></ng-container>
                              </p-popover>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <div
                    class="flex justify-center items-center gap-1 relative h-[35px] mb-2.5"
                    [id]="Id + '-articleBottom'"
                  >
                    <mi-round-button
                      size="sm"
                      [pTooltip]="'ai_suggestions.first' | translate"
                      tooltipPosition="top"
                      appendTo="body"
                      (clicked)="showFirst(item().suggestArticlesResponse, 'article')"
                      icon="mi2-left-arrow-filled"
                    ></mi-round-button>
                    <mi-round-button
                      size="sm"
                      [pTooltip]="'ai_suggestions.previous' | translate"
                      tooltipPosition="top"
                      appendTo="body"
                      (clicked)="showPrevious(item().suggestArticlesResponse, 'article')"
                      icon="mi2-arrow-left"
                    ></mi-round-button>
                    <div class="text-sm font-normal text-color text-center px-1">
                      <span
                        translate
                        [translateParams]="{
                          current: item().suggestArticlesResponse.selectedIndex + 1,
                          total: item().suggestArticlesResponse.articleAnswersList.length
                        }"
                        >ai_suggestions.of</span
                      >
                    </div>
                    <mi-round-button
                      size="sm"
                      [pTooltip]="'ai_suggestions.next' | translate"
                      tooltipPosition="top"
                      appendTo="body"
                      (clicked)="showNext(item().suggestArticlesResponse, 'article')"
                      icon="mi2-arrow-right"
                    ></mi-round-button>
                    <mi-round-button
                      size="sm"
                      [pTooltip]="'ai_suggestions.last' | translate"
                      tooltipPosition="top"
                      appendTo="body"
                      (clicked)="showLast(item().suggestArticlesResponse, 'article')"
                      icon="mi2-right-arrow-filled"
                    ></mi-round-button>
                  </div>
                </div>
              }
              @if (!item().suggestArticlesResponse) {
                <div>
                  <ng-container *ngTemplateOutlet="articleLoadingTemplate"></ng-container>
                </div>
              }
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
      }
      @if (data.type === 'faq') {
        <p-accordion [value]="item().faqExpanded ? 'faq' : null" (valueChange)="onFaqPanelChange($event)">
          <p-accordion-panel value="faq" [style]="{ 'border-bottom': 'none' }">
            <p-accordion-header
              [pt]="{ root: { class: '!bg-[var(--p-content-hover-background)] rounded mb-2' } }"
              styleClass="h-10 min-h-10"
            >
              <div
                class="bg-primary-500 rounded-[0.8em] text-white inline-block font-bold leading-[1.6em] mr-2.5 text-center w-[1.6em]"
              >
                {{ data.total }}
              </div>
              {{ 'ai_suggestions.frequently_asked' | translate }}
              @if (data.recommended) {
                <span
                  class="rounded bg-surface-400 float-right text-center mt-0.5 text-[10px] font-bold text-white px-1"
                  >{{ 'ai_suggestions.recommended' | translate }}</span
                >
              }
            </p-accordion-header>
            <p-accordion-content>
              @if (item().suggestFaqAnswersResponse) {
                <div>
                  @for (faq of item().suggestFaqAnswersResponse.faqAnswersList; track faq) {
                    <div>
                      <div
                        class="rounded border border-surface-200 bg-[var(--p-content-background)] px-2.5 py-0"
                        [ngStyle]="{ display: faq.selected ? 'block' : 'none' }"
                      >
                        <div class="h-[170px] overflow-y-auto">
                          @if (faq.recommended) {
                            <span
                              class="rounded bg-surface-400 text-center mt-1.5 mb-1.5 text-[10px] font-bold text-white px-1 inline-block"
                              >{{ 'ai_suggestions.recommended' | translate }}</span
                            >
                          }
                          <div class="text-[13px] font-normal text-muted-color mt-2.5" [innerHTML]="faq.answer"></div>
                        </div>
                        <div class="outline-none mt-2.5 mb-4">
                          <p-button
                            [outlined]="true"
                            styleClass="text-sm font-semibold mt-1.5 mb-4 rounded-full"
                            [label]="'ai_suggestions.send_answer' | translate"
                            (onClick)="sendFaq(faq)"
                          />
                          @if (showFeedback()) {
                            <button
                              type="button"
                              class="p-0 shadow-none border-0 bg-none bg-transparent outline-none focus-visible:shadow-[0px_0px_0px_3px_rgba(0,115,208,0.24)] float-right inline mt-[9px] cursor-pointer h-6 w-6"
                              [attr.aria-label]="'ai_suggestions.feedback' | translate"
                              (click)="faqFeedbackPopover.toggle($event); setSourceForFeedback(faq)"
                            >
                              <i class="mi2-feedback text-lg"></i>
                            </button>
                            <p-popover #faqFeedbackPopover appendTo="body">
                              <ng-container *ngTemplateOutlet="feedbackTooltipContent"></ng-container>
                            </p-popover>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  <div class="flex justify-center items-center gap-1 relative h-[35px] mb-2.5" [id]="Id + '-faqBottom'">
                    <mi-round-button
                      size="sm"
                      [pTooltip]="'ai_suggestions.first' | translate"
                      tooltipPosition="top"
                      appendTo="body"
                      (clicked)="showFirst(item().suggestFaqAnswersResponse, 'faq')"
                      icon="mi2-left-arrow-filled"
                    ></mi-round-button>
                    <mi-round-button
                      size="sm"
                      [pTooltip]="'ai_suggestions.previous' | translate"
                      tooltipPosition="top"
                      appendTo="body"
                      (clicked)="showPrevious(item().suggestFaqAnswersResponse, 'faq')"
                      icon="mi2-arrow-left"
                    ></mi-round-button>
                    <div class="text-sm font-normal text-color text-center px-1">
                      <span
                        translate
                        [translateParams]="{
                          current: item().suggestFaqAnswersResponse.selectedIndex + 1,
                          total: item().suggestFaqAnswersResponse.faqAnswersList.length
                        }"
                        >ai_suggestions.of</span
                      >
                    </div>
                    <mi-round-button
                      size="sm"
                      [pTooltip]="'ai_suggestions.next' | translate"
                      tooltipPosition="top"
                      appendTo="body"
                      (clicked)="showNext(item().suggestFaqAnswersResponse, 'faq')"
                      icon="mi2-arrow-right"
                    ></mi-round-button>
                    <mi-round-button
                      size="sm"
                      [pTooltip]="'ai_suggestions.last' | translate"
                      tooltipPosition="top"
                      appendTo="body"
                      (clicked)="showLast(item().suggestFaqAnswersResponse, 'faq')"
                      icon="mi2-right-arrow-filled"
                    ></mi-round-button>
                  </div>
                </div>
              }
              @if (!item().suggestFaqAnswersResponse) {
                <div>
                  <ng-container *ngTemplateOutlet="faqLoadingTemplate"></ng-container>
                </div>
              }
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
      }
    </div>
  }
</div>

<ng-template #feedbackTooltipContent>
  <div class="mx-1.5 my-2.5 text-left">
    <div class="font-semibold text-color dark:text-white mb-1.5">
      {{ 'ai_suggestions.how_correct_answer' | translate }}
    </div>
    <div class="text-sm font-normal text-muted-color dark:text-surface-300 mb-2.5">
      {{ 'ai_suggestions.feedback_description' | translate }}
    </div>
    <div>
      <button
        class="p-0 shadow-none border-0 bg-none bg-transparent outline-none w-1/3"
        (click)="feedbackAnswer('FULLY_CORRECT')"
      >
        <span class="text-sm text-green-400">&#10003;&nbsp;{{ 'ai_suggestions.correct' | translate }}</span>
      </button>
      <button
        class="p-0 shadow-none border-0 bg-none bg-transparent outline-none w-1/3"
        (click)="feedbackAnswer('PARTIALLY_CORRECT')"
      >
        <span class="text-amber-400">&#63;&nbsp;{{ 'ai_suggestions.partially' | translate }}</span>
      </button>
      <button
        class="p-0 shadow-none border-0 bg-none bg-transparent outline-none w-1/3"
        (click)="feedbackAnswer('NOT_CORRECT')"
      >
        <span class="text-sm text-red-400">X&nbsp;{{ 'ai_suggestions.wrong' | translate }}</span>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #articleLoadingTemplate>
  <div class="rounded border border-surface-200 bg-[var(--p-content-background)] px-2.5 py-0">
    <span class="rounded bg-surface-400 text-center mt-1.5 mb-1.5 text-[10px] font-bold text-white px-1 inline-block">{{
      'ai_suggestions.recommended' | translate
    }}</span>
    <div class="ph-item">
      <div class="ph-row">
        <div class="ph-col-12 big"></div>
      </div>
    </div>
    <div class="mt-1.5">
      <div class="outline-none mt-2.5 mb-4">
        <p-button
          [outlined]="true"
          styleClass="text-sm font-semibold mt-1.5 mb-4 rounded-full"
          [label]="'ai_suggestions.send_snippet' | translate"
          [disabled]="true"
        />
      </div>
    </div>
    <div class="ph-item">
      <div class="ph-row">
        <div class="ph-col-12 big"></div>
      </div>
    </div>
    <div class="mt-1.5">
      <div class="outline-none mt-2.5 mb-4">
        <p-button
          [outlined]="true"
          styleClass="text-sm font-semibold mt-1.5 mb-4 rounded-full"
          [label]="'ai_suggestions.send_snippet' | translate"
          [disabled]="true"
        />
      </div>
    </div>
  </div>
</ng-template>

<ng-template #faqLoadingTemplate>
  <div class="rounded border border-surface-200 bg-[var(--p-content-background)] px-2.5 py-0">
    <span class="rounded bg-surface-400 text-center mt-1.5 mb-1.5 text-[10px] font-bold text-white px-1 inline-block">{{
      'ai_suggestions.recommended' | translate
    }}</span>
    <div class="ph-item">
      <div class="ph-row">
        <div class="ph-col-12 big"></div>
      </div>
    </div>
    <div class="mt-1.5">
      <div class="outline-none mt-2.5 mb-4">
        <p-button
          [outlined]="true"
          styleClass="text-sm font-semibold mt-1.5 mb-4 rounded-full"
          [label]="'ai_suggestions.send_answer' | translate"
          [disabled]="true"
        />
      </div>
    </div>
  </div>
</ng-template>
